module.exports = __webpack_public_path__ + "static/media/nonord-c-14.7690b416.mp3";